import { render, staticRenderFns } from "./HolidaysBanner.vue?vue&type=template&id=429e2aaf&scoped=true"
var script = {}
import style0 from "./HolidaysBanner.vue?vue&type=style&index=0&id=429e2aaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429e2aaf",
  null
  
)

export default component.exports